import React, { useState, useEffect } from "react";
import "./history.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Nav from "./Nav";

const API_BASE = "https://sangitshreeprakashan.com/backend/api";

export default function OrderHistory() {
  const [search, setSearch] = useState("");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await fetch(
          `${API_BASE}/history.php`,
          {
            credentials: "include" // 🔥 SESSION IMPORTANT
          }
        );

        const data = await response.json();

        if (data.status === "success") {
          setOrders(data.data); // 🔥 FIXED
        } else {
          console.error(data.message);
        }

      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const filteredOrders = orders.filter((order) => {
    const itemsStr = Array.isArray(order.items)
      ? order.items.map(i => i.product_name).join(" ")
      : "";
    return itemsStr.toLowerCase().includes(search.toLowerCase());
  });

  return (
    <>
      <Nav />
      <Navbar />

      <div className="order-history-container">
        <h2 className="order-history-title">Order History</h2>

        {loading ? (
          <p>Loading orders...</p>
        ) : filteredOrders.length === 0 ? (
          <p>No orders found.</p>
        ) : (
          <div className="orders-list">
            {filteredOrders.map((order) => {

              const itemsText = order.items
                ?.map((i) => i.product_name)
                .join(", ");

              const quantityText = order.items
                ?.map((i) => i.qty)
                .join(", ");

              return (
                <div key={order.id} className="order-card">
                  <div className="order-details">

                    <div>
                      <h4>{itemsText}</h4>
                      <p>Qty: {quantityText}</p>
                    </div>

                    <div>
                      <h4>₹{order.total_amount}</h4>
                      <p className="delivered-text">
                        Ordered on{" "}
                        {new Date(order.created_at).toLocaleDateString()}
                      </p>
                    </div>

                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <Footer />
    </>
  );
}